export const OVERDUE_ACCOUNT_OWNER_ERROR = 'subscription-overdue-account-owner-error';

export const OVERDUE_NON_ACCOUNT_OWNER_ERROR = 'subscription-overdue-non-account-owner-error';

export const LEGACY_SUBSCRIPTION_ISSUE_ERROR = 'subscription-issue';
